import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { invitationCodeReportApi } from "../../../utility/api/apiList";

import useAxios from "../../../hooks/useAxios";
import scrollToTop from "../../../libs/scrollToTop";

import LoadingComponent from "../../../components/public/loading";
import UserReferralComponent from "../../../components/private/user/userReferral/userReferralComponent";

const UserReferralContainer = () => {
  const userDetail = useSelector((state) => state.userDetail);
  const { run, isLoading, data } = useAxios({
    url: invitationCodeReportApi,
  });
  useEffect(() => {
    document.title = "دعوت از دوستان";
    scrollToTop();
    run().then();
  }, []);

  const referralCode = userDetail.userDetail[0].usermeta?.invitation_code
    ? userDetail.userDetail[0].usermeta?.invitation_code
    : userDetail.userDetail[0].usermeta?.special_invitation_code;

  return (
    <>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <UserReferralComponent info={data?.result} referralCode={referralCode} />
      )}
    </>
  );
};

export default UserReferralContainer;
